import { useParams, useNavigate } from 'react-router-dom';
import events from './EventData';

export default function EventDetails() {
  const { eventId } = useParams();
  const event = events[parseInt(eventId)];
  const navigate = useNavigate();

  if (!event) return <p>Group not found</p>;

  return (
    <div className="group-details">
      <button onClick={() => navigate(-1)}>← Back</button>
      <p>Event Date: {event.date}</p>
      <p>Event Type: {event.type}</p>
      <h2>{event.title}</h2>
      <img src={event.image} alt={event.name} style={{ width: 200 }} />
      <p>{event.description}</p>
      <p><a href={event.link} target="_blank" rel="noreferrer">{event.link}</a></p>
      <p>Event Address: {event.address}</p>
    </div>
  );
}
